import Home from '@/app/screens/Home'
import NotFound from '@/app/screens/NotFound'
import Contact from '@/app/screens/Contact'
import About from '@/app/screens/About'
import Programs from '@/app/screens/Programs'
import Post from '@/app/screens/Post'
import Search from '@/app/screens/Search'

const routes = [
  Home,
  About,
  Contact,
  Programs,
  Post,
  Search,
  NotFound
]

export default routes



// WEBPACK FOOTER //
// ./src/app/config/routes.js